export default {
  sizeSmall: "Alacsony",
  sizeMedium: "Közepes",
  sizeLarge: "Nagy",
};
